module.exports = __webpack_public_path__ + "static/media/自助销售_lg.e7f6a01f.jpg";